/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import './GrillaEspectaculos.scss';
import { ImageList } from '@mui/material';
import ImageListItem from '@mui/material/ImageListItem';
import Typography from '@mui/material/Typography';
import { theme } from '../../../theme/theme';
import CardEspectaculo from './CardEspectaculo';
import { EspectaculoGrilla, Fecha } from 'utils/models/types';
import { convertirFechasStringAFechas, ordenarPorFecha } from 'utils/utilities';
import { Box } from '@mui/material';
import Paginacion from '../Paginacion/Paginacion';
import HomeContainer from 'components/PageContainer/HomeContainer';
import { anchoMax } from 'utils/constants';

interface GrillaProps {
  titulo: string;
  textoBoton: string;
  elementos: any[];
  path: string;
  mostrarFechas: boolean;
}

const GrillaEspectaculos = ({ titulo, elementos, textoBoton, mostrarFechas, path }: GrillaProps) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const elementosPorPagina = 9;

  const elementosOrdenadosPorFecha = ordenarPorFecha([...elementos]);
  const indiceUltimoElemento = paginaActual * elementosPorPagina;
  const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina;
  const elementosPaginados = elementosOrdenadosPorFecha.slice(indicePrimerElemento, indiceUltimoElemento);

  // Manejar el cambio de página
  const handleChange = (e: any, value: React.SetStateAction<number>) => {
    setPaginaActual(value);
  };

  return (
    <HomeContainer>
      <Box maxWidth={anchoMax} textAlign="left" margin="auto">
        <Typography variant="h3" mb="25px" color={theme.palette.primary.main} fontSize="1.5rem">
          {titulo}
        </Typography>
      </Box>
      <ImageList
        className="grilla"
        sx={{
          maxWidth: anchoMax,
          marginX: 'auto',
          mY: '30px',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)!important',
            md: 'repeat(2, 1fr)!important',
            lg: 'repeat(3, 1fr)!important',
            xl: 'repeat(4, 1fr)!important',
          },
        }}
        gap={30}
      >
        {elementosPaginados.map(({ AficheUrl, Nombre, Fechas, Id }: EspectaculoGrilla) => {
          const fechasDate: Fecha[] = Fechas?.map(convertirFechasStringAFechas);

          const fechaInicio = fechasDate && fechasDate[0]?.FechaInicio;
          const fechaFin = fechasDate && fechasDate[fechasDate?.length - 1]?.FechaInicio;

          return (
            <ImageListItem sx={{ margin: 'auto', height: '100%!important' }} key={`${Id}-${Nombre}`}>
              <CardEspectaculo
                id={Id}
                img={AficheUrl}
                titulo={Nombre}
                path={path}
                fechaIni={fechaInicio}
                fechaFin={fechaFin}
                textoBoton={textoBoton}
                mostrarFechas={mostrarFechas}
              />
            </ImageListItem>
          );
        })}
      </ImageList>

      <Paginacion
        elementos={elementosOrdenadosPorFecha}
        elementosPorPag={elementosPorPagina}
        paginaActual={paginaActual}
        handleChange={handleChange}
      />
    </HomeContainer>
  );
};

export default GrillaEspectaculos;
